import { Demo } from './components/landing Page/SliderComponent';
import { LandingPage } from './components/landing Page/LandingPage';
import { Navbar } from './components/Navbar';
import { Register } from './components/Register';
import { JobDetail } from './components/JobDetail';
import { ProfilePage } from './components/ProfilePage';
import { SingleJObTemplate } from './components/singleJobTemplate';
import { JobSearch } from './components/JobSearch';
import { AllRoutes } from './components/AllRoute/AllRoutes';

function App() {
  return (
    <div >
      {/* <JobDetail /> */}
      <AllRoutes />
    </div>
  );
}

export default App;
